/**
 * @typedef { import('../../time.js').YearMonthPeriod } YearMonthPeriod
 * @typedef { import('../../time.js').YearMonthPeriodObject } YearMonthPeriodObject
 * @typedef { import('../../time.js').YearMonth } YearMonth
 * @typedef { import('./retention_report.js').Report } Report
 * @typedef { import('./retention_report.js').Cohort } Cohort
 */

/**
 * @param {Report} report
 * @returns {string}
 */
export function convertRetentionReportToTableString(report) {
  let str = "cohort,login_month,players\n";

  const period = report.getPeriod();

  const beginMonth = period.getBegin();
  const endMonth   = period.getEnd();

  for(let month = beginMonth; month.isBefore(endMonth); month = month.getNext()) {
    const cohort = report.getCohortByMonth(month);
    const cohortStr = convertCohortToMetricString(cohort, endMonth);
    str += cohortStr + "\n";
  }

  return str;
}

/**
 * @param {Cohort} cohort
 * @param {YearMonth} endMonth
 * @returns {string}
 */
function convertCohortToMetricString(cohort, endMonth) {
  /** @type {string[]} */
  const strs = [
    convertMetricToString(cohort, cohort.getYearMonth(), cohort.getSize())
  ];

  const metricBeginMonth = cohort.getYearMonth().getNext();
  for(let month = metricBeginMonth; month.isBefore(endMonth); month = month.getNext()) {
    const value = cohort.getMetricValueByMonth(month);
    const str = convertMetricToString(cohort, month, value);
    strs.push(str);
  }

  return strs.join("\n");
}

/**
 * @param {Cohort} cohort
 * @param {YearMonth} metricMonth
 * @param {number} metricValue
 * @returns {string}
 */
function convertMetricToString(cohort, metricMonth, metricValue) {
  const parts = [
    cohort.getName(),
    metricMonth.toString(),
    metricValue,
  ];

  return parts.join(',');
}
